import React, { useState, useRef, useEffect } from "react";
import { IoChevronDown } from "react-icons/io5";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import AssignChange from "../../../../components/order/Change/AssignChange";
import AddRemarkMessage from "../../../../components/order/Change/AddRemarkMessage";
import TextInput from "../../../../components/form/TextInput";
import denyChangeTicketRequest from "../../../../controllers/booking/postTicketing/change/denyChangeTicketRequest";
import { enqueueSnackbar } from "notistack";
import Button1 from "../../../../components/form/Button1";
import approveChangeTicketRequest from "../../../../controllers/booking/postTicketing/change/approveChangeTicketRequest";
import ManualChangeQuote from "../../../../components/order/Change/ManualChangeQuote";
import submitChange from "../../../../controllers/booking/postTicketing/change/submitChange";
import { isGDSSupplier } from "../../../../data/flight/supplier/getSupplierName";
import ManualUpdate from "../../../../components/order/Change/ManualUpdate";
import { useSearchParams } from "react-router-dom";

function ChangeDateConfirmationManageOrder({ data }) {
  const [manageMenu, setManageMenu] = useState(false);
  const [searchParams] = useSearchParams();
  const [modal, setModal] = useState({
    assignTask: false,
    remark: false,
    reject: false,
    approve: false,
    quote: false,
    submission: false,
    confirm: false,
  });
  const [loading, setLoading] = useState({
    reject: false,
    approve: false,
    submission: false,
  });
  const [rejectReason, setRejectReason] = useState(data?.rejectReason);
  const menuRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        manageMenu &&
        !menuRef.current?.contains(event.target) &&
        !buttonRef.current?.contains(event.target)
      ) {
        setManageMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [manageMenu]);

   useEffect(() => {
    const modalParam = searchParams.get("modal");

    if (!modalParam) return;

    setModal((prev) => ({
      ...prev,
      [modalParam]: true, 
    }));
  }, [searchParams]);

  const og = {
    ...data,
    flightBooking: [data?.flightBooking],
    flightObj: data?.flightBooking,
    type: "Flight",
  };

  const menuItems = [
    {
      label: data?.payable ? "Edit Quote" : "Create Quote",
      action: () => {
        setModal({ ...modal, quote: true });
      },
      visible: ["Approved"].includes(data?.status),
    },
    {
      label: "Assign Request",
      action: () => {
        setModal({ ...modal, assignTask: true });
      },
      visible: ["Paid", "Approved", "Pending"].includes(data?.status),
    },
    {
      label: "Accept Request",
      action: () => {
        setModal({ ...modal, approve: true });
      },
      visible: ["Pending"].includes(data?.status),
    },
    {
      label: "Add Remark",
      action: () => {
        setModal({ ...modal, remark: true });
      },
      visible: ["Paid", "Approved", "Pending"].includes(data?.status),
    },
    {
      label: "Confirm Airline Submission",
      action: () => {
        setModal({ ...modal, submission: true });
      },
      visible: ["Paid"].includes(data?.status),
    },
    {
      label: "Confirm Re-issue",
      action: () => {
        setModal({ ...modal, confirm: true });
      },
      visible: ["PendingChange", "Pending Reissue"].includes(data?.status),
    },
    {
      label: "GDS Re-issue",
      action: () => {
        setModal({ ...modal, assignTask: true });
      },
      visible:
        ["PendingChange", "Pending Reissue"].includes(data?.status) &&
        isGDSSupplier(og?.supplier || og?.flightObj?.supplier),
    },
    {
      label: "Decline Request",
      action: () => {
        setModal({ ...modal, reject: true });
      },
      visible: ["Approved", "Pending", "Paid"].includes(data?.status),
    },
  ].filter((item) => item.visible);

  async function handleDenyChange() {
    const reqBody = {
      // ticketQueueId: _id,
      rejectReason,
    };
    setLoading({ ...loading, reject: true });
    const res = await denyChangeTicketRequest(data?._id, reqBody).finally(
      () => {
        setLoading({ ...loading, reject: false });
      }
    );

    if (res.return) {
      enqueueSnackbar("Request has been denied.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleApproveChange() {
    setLoading({ ...loading, approve: true });
    const res = await approveChangeTicketRequest(data?._id).finally(() =>
      setLoading({ ...loading, approve: false })
    );
    if (res.return) {
      enqueueSnackbar("Request has been approved.", { variant: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleSubmitChange() {
    setLoading({ ...loading, submission: true });
    const res = await submitChange(data?._id).finally(() =>
      setLoading({ ...loading, submission: false })
    );
    if (res?.return) {
      enqueueSnackbar(res?.msg || "Change submitted successfully", {
        variant: "success",
      });
      setTimeout(() => {
        window.location.reload();
      }, 300);
    } else
      enqueueSnackbar(res?.msg || "Failed to submit Change", {
        variant: "error",
      });
  }

  if (menuItems?.length === 0) return <></>;

  //   console.log({ order: convertFlightObject(data) });
  return (
    <div className="relative w-full lg:w-fit">
      <Modal3
        open={modal.confirm}
        setOpen={(modalState) => setModal({ ...modal, confirm: modalState })}
        title="Re-Issue"
      >
        <div className="p-4 max-w-[700px]">
          <ManualUpdate
            callback={() => window.location.reload()}
            data={og}
            close={() => setModal({ ...modal, confirm: false })}
          />
        </div>
      </Modal3>
      <Modal3
        open={modal.submission}
        setOpen={(modalState) => setModal({ ...modal, submission: modalState })}
        title={"Submit Change Request"}
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            Do you confirm you have requested change to the airline?
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setModal({ ...modal, submission: false })}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleSubmitChange()}
                loading={loading?.submission}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.quote}
        setOpen={(modalState) => setModal({ ...modal, quote: modalState })}
        title={"Quote"}
      >
        <div className="p-4 max-w-[800px] md:min-w-[500px]">
          <ManualChangeQuote
            data={og}
            reload={() => window.location.reload()}
            close={() => setModal({ ...modal, quote: false })}
          />
        </div>
      </Modal3>
      <Modal3
        open={modal.reject}
        setOpen={(modalState) => setModal({ ...modal, reject: modalState })}
        title={"Decline Ticket Re-issue Request"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          {/* <h5>What's your reson?</h5> */}
          <TextInput
            label="Remark"
            multiline
            rows={5}
            placeholder={"e.g. Ticket not available"}
            value={rejectReason || ""}
            onChange={(ev) => setRejectReason(ev.target.value)}
          />
          <div className="flex justify-end items-center gap-4">
            <div>
              <Button1
                variant="outlined"
                className="btn-outlined flex-1"
                onClick={() => setModal({ ...modal, reject: false })}
              >
                Cancel
              </Button1>
            </div>
            <Button1
              onClick={() => handleDenyChange()}
              loading={loading?.reject}
            >
              Continue
            </Button1>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.approve}
        setOpen={(modalState) => setModal({ ...modal, approve: modalState })}
        title={"Confirm Re-Issue Request Approval"}
      >
        <div className="max-w-[500px] p-4">
          <div className="p-4">
            <p>
              Are you sure you want to approve the re-issue of this ticket? This
              action will override the current ticket details.
            </p>
          </div>
          <div className="flex gap-4">
            <Button1
              variant="text"
              onClick={() => setModal({ ...modal, approve: false })}
            >
              Cancel
            </Button1>
            <Button1
              loading={loading?.approve}
              onClick={() => handleApproveChange()}
            >
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={modal.assignTask}
        setOpen={(modalState) => setModal({ ...modal, assignTask: modalState })}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignChange callback={() => window.location.reload()} data={og} />
        </div>
      </Modal3>
      <Modal3
        open={modal.remark}
        setOpen={(modalState) => setModal({ ...modal, remark: modalState })}
        title={"Add an update"}
      >
        <div className="card p-4 flex flex-col  gap-4 md:min-w-[500px]">
          <AddRemarkMessage
            callback={() => window.location.reload()}
            data={og}
          />
        </div>
      </Modal3>
      <button
        ref={buttonRef}
        onClick={() => setManageMenu((prev) => !prev)}
        className="border border-gray-300 h-12 rounded-md bg-gray-100 hover:bg-gray-200 transition-all w-full px-2 lg:px-4 flex items-center justify-center gap-2 text-sm font-semibold"
      >
        <span>Manage order</span>
        <IoChevronDown
          className={`text-base transition-transform mt-[2px] ${
            manageMenu ? "rotate-180" : ""
          }`}
        />
      </button>

      {manageMenu && (
        <div
          ref={menuRef}
          className="absolute right-0 mt-2 w-44 rounded-md border border-gray-200 bg-white shadow-lg overflow-hidden z-20"
        >
          {menuItems.map((itm, idx) => (
            <button
              key={idx}
              onClick={() => {
                setManageMenu(false);
                itm.action?.();
              }}
              className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
            >
              {itm.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ChangeDateConfirmationManageOrder;
